import styled from 'styled-components';
import { Box } from '@interstate/components/Box';
import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const CreditSourceBannerContainer = styled(Box)<{ interstateTheme: InterstateTheme }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    padding: 8px 16px;
    border: 1px solid ${({ interstateTheme }) => interstateTheme.tokens.SemColorBorderMuted};
    border-radius: 4px;
    background: #fafafa;
    margin-bottom: 20px;

    .credit-source-banner-icon-wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const AiAffordabilitySlideoutContainer = styled(Box)`
    .MuiPaper-root > div {
        padding: 10px !important;
    }

    .ai-vehicle-recommendation-slideout-cards-container {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .ai-vehicle-recommendation-slideout-card {
            user-select: none;
            padding: 16px;
            border: 1px solid #828282;
            border-radius: 4px;
            cursor: pointer;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
            &:active {
                transform: scale(0.98);
            }
        }

        .ai-vehicle-recommendation-slideout-card.primary {
            background: #ebf6ff;
            border: 2px solid #003468;
        }

        .ai-vehicle-recommendation-slideout-card-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .MuiFormControlLabel-label {
                font-weight: 600;
                &.Mui-disabled {
                    color: #000000;
                }
            }
        }

        .ai-vehicle-recommendation-slideout-cards-divider {
            height: 1px;
            background-color: #000000;
        }

        .ai-vehicle-recommendation-slideout-header-primary {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 4px;
            background: #cce8ff;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 16px;
        }

        .ai-vehicle-recommendation-slideout-vehicle-info {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 8px;

            img {
                width: 124px;
                height: 58px;
                object-fit: scale-down;
            }

            .ai-vehicle-recommendation-slideout-vehicle-details {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                color: #5a5a5a;
            }
        }

        .ai-vehicle-recommendation-slideout-vehicle-payment-details {
            display: flex;
            flex-direction: column;
            gap: 4px;

            .ai-vehicle-recommendation-slideout-profit-approval-wrapper {
                .ai-vehicle-recommendation-slideout-profit-approval-container {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    margin-top: 16px;
                }
            }

            .ai-vehicle-recommendation-slideout-detail-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                .ai-vehicle-recommendation-slideout-detail-item-label {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                label {
                    color: #6d6d6d;
                }
            }
        }
    }
`;
